import React from 'react';
import * as lib from '~/dependencies';
import Row from './Row';

const List = ({ numRows }) => (
  <>
    {Array.from({ length: numRows }, rowId => (
      <Row key={rowId} />
    ))}
  </>
);

export default List;

List.defaultProps = {
  numRows: 6,
};

List.propTypes = {
  numRows: lib.PropTypes.number,
};
